import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SidebarHeader from './SidebarHeader';
import { IconType } from 'react-icons';
import {
  ChevronRightIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
} from '@heroicons/react/solid';
import { VscDash } from 'react-icons/vsc';
import { BiBookContent } from 'react-icons/bi';
import { RouteItem } from '@wajeez-web/core/types';
import { useCommonSelector } from '@wajeez-web/stores/common';
import { useAuthSelector } from '@wajeez-web/stores/auth';
import { HasPermissionWrapperComponent } from '@wajeez-web/components/helpers';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(' ');
}

interface SidebarContainerProps {
  navigation: RouteItem[];
  withSettings?: boolean;
}

const SidebarContainer = ({
  navigation,
  withSettings = true,
}: SidebarContainerProps) => {
  const { theme, dir } = useCommonSelector((state) => state.common.settings);
  const { user } = useAuthSelector((state) => state.auth);

  // const { contentEntityTypes } = useAppSelector(
  //   (state) => state.contentEntityTypes
  // );
  const [selectedSideNavItem, setSelectedSideNavItem] = useState<number | null>(
    null
  );
  const [extraNavigations, setExtraNavigations] = useState<
    SidebarContainerProps['navigation']
  >([]);
  const location = useLocation();

  const onSelect = (index: number) => () => {
    if (index === selectedSideNavItem) {
      setSelectedSideNavItem(null);
    } else {
      setSelectedSideNavItem(index);
    }
  };

  // useEffect(() => {
  //   theme === 'base' &&
  //     setExtraNavigations([
  //       {
  //         name: 'Content',
  //         href: '/content-entities',
  //         per:
  //           contentEntityTypes.map((item) => item.permission).toString() +
  //           '31.0,68.0',
  //         icon: BiBookContent,
  //         children: [
  //           {
  //             name: 'Authors',
  //             href: '/authors',
  //             per: '31.0',
  //           },
  //           {
  //             name: 'Narrators',
  //             href: '/narrators',

  //             per: '68.0',
  //           },
  //           {
  //             name: 'Free Daily Book',
  //             href: '/daily-content',
  //             children: [],
  //             per: '83.2',
  //           },
  //         ].concat(
  //           contentEntityTypes
  //             .filter(
  //               (item: { name: string; shownInSideBar: boolean }) =>
  //                 item.shownInSideBar
  //             )
  //             .map((item) => ({
  //               name: item.displayNamePlural || item.name,
  //               href: `/content-entities/type/${item.name}`,
  //               per: item.permission,
  //             }))
  //             .concat([
  //               {
  //                 name: 'Suggest Content',
  //                 href: '/SuggestContent',
  //                 per: '80.0',
  //               },
  //               {
  //                 name: 'Reported Text Problem',
  //                 href: '/Customers/report-text-problem',
  //                 per: '98.6',
  //               },
  //             ])
  //         ),
  //       },
  //     ]);
  // }, [contentEntityTypes]);

  const containsExcludedPathnames = (
    pathname: string | undefined,
    exclude: string[] | undefined
  ) => {
    let contains = false;

    if (exclude) {
      for (const ex of exclude) {
        if (location.pathname.includes(ex)) {
          contains = true;

          break;
        }
      }
    }

    return contains;
  };

  return (
    <div className="flex flex-col me-1 space-y-2   h-screen sm:h shadow  flex-shrink-0 items-center border-e shadow-slate-300  border-warmGray-200  overflow-hidden   bg-gradient-to-b from-sidebar-bg-from to-sidebar-bg-to w-56  lg:w-56  md:w-40  ">
      <SidebarHeader withSettings={withSettings} />

      <div className="flex flex-col justify-center items-center ">
        <div className="h-16 w-16 xl:h-24 xl:w-24 lg:h-16 lg:w-16 md:w-14 md:h-14 rounded-full bg-ring-color p-4 text-center flex justify-center items-center align-middle text-5xl xl:text-7xl lg:text-5xl md:text-4xl font-bold capitalize">
          {user.name?.[0] || user.email[0]}
        </div>
        <div className="mt-4 w-full px-2 xl:text-lg lg:text-base md:text-sm whitespace-nowrap text-ellipsis overflow-hidden  text-center leading-normal font-semibold">
          {user.name}
        </div>
        <div
          className="
           w-full px-2 overflow-hidden break-words text-center xl:text-base lg:text-sm md:text-xs leading-normal font-semibold text-textSecondary"
        >
          {user.email}
        </div>
      </div>
      <div className="w-full px-2 justify-between h-full flex flex-col   hover:scrollbar-thumb-[#2C3344] scrollbar-track-transparent scrollbar-thin">
        <div className="flex flex-col items-center w-full  ">
          <nav className=" space-y-2 w-full  py-3">
            {extraNavigations.concat(navigation).map((item, i) => {
              return (
                <div className="space-y-2" key={item.name + i}>
                  {item.children != undefined && item.children.length ? (
                    <HasPermissionWrapperComponent permissions={item.per}>
                      <div>
                        <div
                          onClick={onSelect(i)}
                          key={item.name}
                          className={classNames(
                            location.pathname === item.href ||
                              item.children.find(
                                (ele) => location.pathname === ele.href
                              )
                              ? ` bg-sidebar-selected-bg rounded-md text-sidebar-selected-text `
                              : ` text-sidebar-text  hover:text-sidebar-selected-text hover:bg-sidebar-selected-bg  `,
                            ` group px-1 rounded-md flex cursor-pointer items-center mt-2  py-2  xl:text-base lg:text-sm  font-semibold`
                          )}
                        >
                          {item.icon !== undefined && (
                            <item.icon
                              className={classNames(
                                'me-3 xl:h-5 xl:w-5 lg:h-4 lg:w-4'
                              )}
                              aria-hidden="true"
                            />
                          )}

                          {
                            <ReturnTranslatedText
                              origintext={item.name}
                              text={`sidebar.${item.name}.title`}
                            />
                          }
                          {
                            <p className="ms-auto my-auto">
                              {i === selectedSideNavItem ? (
                                <ChevronDownIcon className="xl:h-5 xl:w-5 h-4 w-4  " />
                              ) : dir === 'ltr' ? (
                                <ChevronRightIcon className="xl:h-5 xl:w-5 h-4 w-4 " />
                              ) : (
                                <ChevronLeftIcon className="xl:h-5 xl:w-5 h-4 w-4 " />
                              )}
                            </p>
                          }
                        </div>
                        {selectedSideNavItem === i && (
                          <div className="space-y-2  ">
                            {item.children.map((ele) => (
                              <React.Fragment key={ele.name + i}>
                                <HasPermissionWrapperComponent
                                  permissions={ele.per}
                                >
                                  <Link
                                    key={ele.name + i}
                                    to={ele.href + (ele.searchParams || '')}
                                  >
                                    <div
                                      key={ele.name}
                                      className={classNames(
                                        ele.href === location.pathname
                                          ? ` bg-sidebar-selected-bg text-sidebar-selected-text `
                                          : `text-sidebar-text hover:  hover:text-sidebar-selected-text hover:bg-sidebar-selected-bg`,
                                        ` group rounded-md mt-2 px-1 capitalize flex cursor-pointer items-center  py-2  xl:text-base lg:text-sm font-medium `
                                      )}
                                    >
                                      <VscDash
                                        className={classNames(
                                          'me-3 xl:h-5 xl:w-5 lg:h-4 lg:w-4'
                                        )}
                                        aria-hidden="true"
                                      />
                                      {
                                        <ReturnTranslatedText
                                          origintext={ele.name}
                                          text={`sidebar.${item.name}.${ele.name}`}
                                        />
                                      }
                                    </div>
                                  </Link>
                                </HasPermissionWrapperComponent>
                              </React.Fragment>
                            ))}
                          </div>
                        )}
                      </div>
                    </HasPermissionWrapperComponent>
                  ) : (
                    <HasPermissionWrapperComponent permissions={item.per}>
                      <Link key={i} to={item.href + (item.searchParams || '')}>
                        <div
                          key={item.name}
                          className={classNames(
                            (location.pathname.includes(item.href) &&
                              location.pathname === item.href) ||
                              (location.pathname.includes(item.href) &&
                                location.pathname !== item.href &&
                                ((item.exclude &&
                                  !containsExcludedPathnames(
                                    location.pathname,
                                    item.exclude
                                  )) ||
                                  !item.exclude))
                              ? ` bg-sidebar-selected-bg  text-sidebar-selected-text `
                              : `text-sidebar-text hover: hover:text-sidebar-selected-text hover:bg-sidebar-selected-bg`,
                            ` group  flex items-center px-1 rounded-md cursor-pointer py-2 mt-2 xl:text-base lg:text-sm font-semibold `
                          )}
                        >
                          {item.icon !== undefined && (
                            <item.icon
                              className={classNames(
                                'me-3 xl:h-5 xl:w-5 lg:h-4 lg:w-4'
                              )}
                              aria-hidden="true"
                            />
                          )}
                          <ReturnTranslatedText
                            origintext={item.name}
                            text={`sidebar.${item.name}`}
                          />
                        </div>
                      </Link>
                    </HasPermissionWrapperComponent>
                  )}
                </div>
              );
            })}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default SidebarContainer;
